export const BANNER_NAME = 'polaris.blueprints-feedback-banner';

export const BANNER_HEIGHT = 48;
export const MIN_BANNER_WIDTH = 320;

export const ENTRY_POINT_ID = 'jira.polaris.blueprints-feedback-banner';
export const PACKAGE_NAME = 'jiraPolarisComponentBlueprintsFeedbackBanner';
